import { ddRumError } from '@/utils/datadog';
import type videojs from 'video.js';

type Player = typeof videojs.players;
type SetVideoReady = (isReady: boolean) => void;

export const defaultLoadMetadata = (player: Player) => {
    player.on('loadedmetadata', () => {
        const duration = player.children_?.[0]?.duration;
        if (duration !== undefined) {
            player.children_?.[0]?.setAttribute('video-duration', duration?.toFixed(2));
        }
    });
};

export const onError = (player: Player, setIsVideoReady: SetVideoReady) => {
    player?.on('error', (err: any) => {
        player.dispose();
        setIsVideoReady(false);
        ddRumError({
            name: 'Video Error',
            description: `HOMEPAGE - Cannot play video from ${player.currentSource().src}`,
            stack: err,
            use_case: 'HOMEPAGE'
        });
    });
};

/**
 * Determines the media type based on the source video url
 * @param url video source url
 * @returns {string|null}
 */
export const detectVideoTypeFromSource = (url: string): string => {
    switch (true) {
        case /^.*\.m3u8$/.test(url):
            return 'application/x-mpegURL';
        case /^.*\.mp4$/.test(url):
            return 'video/mp4';
        default:
            return '';
    }
};
